export const PANEL_TYPES = { SUMMARY: "summary", ELEMENTS: "elements" };

export const SELECTED_ELEMENTS_LIST_DROPPABLE_ID =
  "droppable-selected-element-container";

export const ELEMENTS_LIST_DROPPABLE_ID = "droppable-element-container";

export const PREVIEW_CONTAINER_DROPPABLE_ID =
  "droppable-form-preview-container";

export const DROPPABLE_TYPES = {
  ELEMENT: "element",
  SELECTED_ELEMENT: "selected_element",
};
